export default __webpack_public_path__ + "static/media/kubernetes.7f03e72a.png";